import { schema } from 'normalizr';

export const currencyRateBuySell = new schema.Entity(
  'currencyRateBuySell',
  {},
  {
    idAttribute: () => null,
    processStrategy: item => ({
      val: item.val,
      trend: item.trend,
      timestamp: item.timestamp,
    }),
  }
);

export const convertorCurrencyRatesBuySell = currencyRateBuySell;
